/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Execution_Modal_Close_CtaInputs */

const en_toast_execution_modal_close_cta = /** @type {(inputs: Toast_Execution_Modal_Close_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const de_toast_execution_modal_close_cta = /** @type {(inputs: Toast_Execution_Modal_Close_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließen`)
};

const pt_br2_toast_execution_modal_close_cta = /** @type {(inputs: Toast_Execution_Modal_Close_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar`)
};

const tr_toast_execution_modal_close_cta = /** @type {(inputs: Toast_Execution_Modal_Close_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapat`)
};

const zh_cn2_toast_execution_modal_close_cta = /** @type {(inputs: Toast_Execution_Modal_Close_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭`)
};

const zh_hk2_toast_execution_modal_close_cta = /** @type {(inputs: Toast_Execution_Modal_Close_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`關閉`)
};

const ko_kr2_toast_execution_modal_close_cta = /** @type {(inputs: Toast_Execution_Modal_Close_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`닫기`)
};

const ru_ru2_toast_execution_modal_close_cta = /** @type {(inputs: Toast_Execution_Modal_Close_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть`)
};

const es_419_toast_execution_modal_close_cta = /** @type {(inputs: Toast_Execution_Modal_Close_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar`)
};

/**
* | output |
* | --- |
* | "Close" |
*
* @param {Toast_Execution_Modal_Close_CtaInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const toast_execution_modal_close_cta = /** @type {((inputs?: Toast_Execution_Modal_Close_CtaInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Execution_Modal_Close_CtaInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_toast_execution_modal_close_cta(inputs)
	if (locale === "de") return de_toast_execution_modal_close_cta(inputs)
	if (locale === "pt-BR") return pt_br2_toast_execution_modal_close_cta(inputs)
	if (locale === "tr") return tr_toast_execution_modal_close_cta(inputs)
	if (locale === "zh-CN") return zh_cn2_toast_execution_modal_close_cta(inputs)
	if (locale === "zh-HK") return zh_hk2_toast_execution_modal_close_cta(inputs)
	if (locale === "ko-KR") return ko_kr2_toast_execution_modal_close_cta(inputs)
	if (locale === "ru-RU") return ru_ru2_toast_execution_modal_close_cta(inputs)
	return es_419_toast_execution_modal_close_cta(inputs)
});